"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLSReportProcessor = void 0;
const attribution_1 = require("web-vitals/attribution");
const events_1 = require("../constants/events");
const webVitals_1 = require("../constants/webVitals");
const WebVitalsMetric_1 = __importDefault(require("./WebVitalsMetric"));
const getLayoutShiftEntries_1 = __importDefault(require("./getLayoutShiftEntries"));
const prepCLSEntries_1 = __importDefault(require("./prepCLSEntries"));
/**
 * Report processor for CLS metric which multiplies the CLS value by `CLS_MULT`,
 * and determines which HTML elements are responsible for the CLS (only if CLS
 * is worse than "good")
 * @param {Object} metricReport - The original metric report
 * @param {Debug} debug - Global Debug instance
 * @returns {Object} The updated metric report
 * @private
 */
const CLSReportProcessor = (metricReport, debug) => {
    const CLSValue = metricReport.value * webVitals_1.CLS_MULT;
    const newMetricReport = Object.assign(Object.assign({}, metricReport), { value: CLSValue });
    // Determine and track HTML elements responsible for this CLS update
    // but only if it is worse than "good".
    if (CLSValue > webVitals_1.WEB_VITALS_THRESHOLDS.CLS.good) {
        newMetricReport.badCLSEntries = (0, getLayoutShiftEntries_1.default)(metricReport);
        debug.log('Bad CLS entries', newMetricReport.badCLSEntries);
    }
    // Return the updated report
    return newMetricReport;
};
exports.CLSReportProcessor = CLSReportProcessor;
/** Custom subclass of `WebVitalsMetric` for CLS */
class CLSMetric extends WebVitalsMetric_1.default {
    constructor(debug) {
        super(events_1.EVENT_NAMES.WEB_VITALS.CLS, attribution_1.onCLS, debug, {
            defaultValue: 0,
            goodThreshold: webVitals_1.WEB_VITALS_THRESHOLDS.CLS.good,
            processReport: CLSReportProcessor,
        });
        // Add a custom property to store the latest bad CLS entries
        this.latestReport = Object.assign(Object.assign({}, this.latestReport), { badCLSEntries: null });
    }
    /**
     * Sort and return any HTML elements that contributed to a bad CLS score
     * (i.e. CLS score worse than "good") or `null` if there aren't any.
     *
     * @deprecated This was used to collect additional details about CLS before
     *   metric attribution was available. It is now deprecated in favor of
     *   `getAttribution()`
     */
    getBadCLSEntries() {
        const { badCLSEntries } = this.latestReport;
        return badCLSEntries && (0, prepCLSEntries_1.default)(badCLSEntries);
    }
}
exports.default = CLSMetric;
